import React , { Fragment } from 'react'
import { useState , useEffect } from 'react'
import {TabPanel} from "./../../../Components/Tab/Tab"
import DomesticForm from './DomesticForm';
import IntraCityForm from './IntraCityForm';
import PartloadForm from "./PartloadForm"
import FullloadForm from './FullloadForm';
import PackersAndMoversForm from './PackersAndMoversForm';
import InterNationalForm from './InterNationalForm';
import "../../../Components/HomePage_Common_Tab/CommonHomeTab.css"
import { RiTruckLine } from "react-icons/ri";
import { useHistory } from "react-router-dom"

const Home = () => {
  let mobileviewinitial = window.innerWidth > 770 ? false : true;
  const [ismobileview, setismobileview] = useState(mobileviewinitial);
  const [tabValue, setTabValue] = useState(0);
  // const [numberval2,setNumberval2] = useState(0);
  // const [lastTab,setLastTab] = useState("");

  // const topFunction = (props:any)=>{
  //   document.body.scrollTop = 0;
  //   {props.head === "Intra City" ? 
  //   document.documentElement.scrollTop = 10 : 
  //   props.head === "Domestic" ? document.documentElement.scrollTop = 70 :   
  //   props.head === "Part Load" ? document.documentElement.scrollTop = 145 :
  //   props.head === "Full Load" ? document.documentElement.scrollTop = 200 :   
  //   props.head === "Packers & Movers" ? document.documentElement.scrollTop = 275 :
  //   props.head === "International" ? document.documentElement.scrollTop = 335 : document.documentElement.scrollTop = 0}   
  // }

  useEffect(() => {
    function handleresize() {
      if (window.innerWidth > 770) {
        setismobileview(false);
      } else {
        setismobileview(true);
      }
    }
    window.addEventListener("resize", handleresize);
    return () => {
      window.removeEventListener("resize", handleresize);
    };
  }, []);

  useEffect(()=>{
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },[tabValue])

  const handleChange = (value: any) => {
    setTabValue(value);
  };

  // const MyArr:any = [ {head:"Intra City",tabName:"Intra City"},
  //                     {head:"Domestic",tabName:"Domestic"},
  //                     {head:"Part Load",tabName:"Part Load"},
  //                     {head:"Full Load",tabName:"Full Load"},
  //                     {head:"Packers & Movers",tabName:"Packers & Movers"},
  //                     {head:"International",tabName:"International"}]

  // const handleClick = (e:any,i:number) => {
  //   setLastTab(e.head);
  //   {lastTab == e.head ? <>
  //       {setNumberval2(0)} 
  //       {setLastTab("")}
  //   </>
  //   : setNumberval2(i+1)}
  // }
  
  const historyForHomePage = useHistory();

  const handleTabsClick = (val:any)=>{
    historyForHomePage.push(`/${val}`)
  }
  
  return (
    <Fragment>
      {ismobileview ? (
        <>
          <>
          {/* <div className='Container2'>
            {MyArr.map((e:any,i:number)=>{
                  return(
                  <div className="question-wrapper2">
                    <div className={lastTab !== "" && lastTab === e.head ? 'question2 qustion2Active' : 'question2'} onClick={() => {handleClick(e,i), topFunction(e)}}>
                      <div className={lastTab !== "" && lastTab === e.head ? 'normalHeading h6New' : 'normalHeading'}>{e.head}</div>
                      <div className={e.head === "Intra City" ? "ml195" : e.head === "Domestic" ? "ml192" : e.head === "Part Load" ? "ml192" : 
                                      e.head === "Full Load" ? "ml198" : e.head === "Packers & Movers" ? "ml100" : e.head === "International" ? "ml154" : ""}>
                        {lastTab !== "" && lastTab === e.head ? <FaChevronUp /> : <FaChevronDown />}
                      </div>
                    </div>
                    <div className={numberval2 === 1? 'answer2 mt10px active' : 'answer2 mt10px'}>
                        {e.tabName === "Intra City" && numberval2 === 1 ? <TabPanel value={""} index={""}> <IntraCityForm /> </TabPanel> : ""}
                        {e.tabName === "Domestic" && numberval2 === 2 ? <TabPanel value={""} index={""}> <DomesticForm /> </TabPanel> : ""}
                        {e.tabName === "Part Load" && numberval2 === 3 ? <TabPanel value={""} index={""}> <PartloadForm /> </TabPanel> : ""}
                        {e.tabName === "Full Load" && numberval2 === 4 ? <TabPanel value={""} index={""}> <FullloadForm /> </TabPanel> : ""}
                        {e.tabName === "Packers & Movers" && numberval2 === 5 ? <TabPanel value={""} index={""}> <PackersAndMoversForm /> </TabPanel> : ""}
                        {e.tabName === "International" && numberval2 === 6  ? <TabPanel value={""} index={""}> <InterNationalForm /> </TabPanel>  : ""}
                    </div>
                    <div className={numberval2 === 2? 'answer2 mt10px active' : 'answer2 mt10px'}>
                        {e.tabName === "Intra City" && numberval2 === 1 ? <IntraCityForm /> : ""}
                        {e.tabName === "Domestic" && numberval2 === 2 ? <DomesticForm /> : ""}
                        {e.tabName === "Part Load" && numberval2 === 3 ? <PartloadForm /> : ""}
                        {e.tabName === "Full Load" && numberval2 === 4 ? <FullloadForm /> : ""}
                        {e.tabName === "Packers & Movers" && numberval2 === 5 ? <PackersAndMoversForm /> : ""}
                        {e.tabName === "International" && numberval2 === 6  ? <InterNationalForm /> : ""}
                    </div>
                    <div className={numberval2 === 3? 'answer2 mt10px active' : 'answer2 mt10px'}>
                        {e.tabName === "Intra City" && numberval2 === 1 ? <IntraCityForm /> : ""}
                        {e.tabName === "Domestic" && numberval2 === 2 ? <DomesticForm /> : ""}
                        {e.tabName === "Part Load" && numberval2 === 3 ? <PartloadForm /> : ""}
                        {e.tabName === "Full Load" && numberval2 === 4 ? <FullloadForm /> : ""}
                        {e.tabName === "Packers & Movers" && numberval2 === 5 ? <PackersAndMoversForm /> : ""}
                        {e.tabName === "International" && numberval2 === 6  ? <InterNationalForm /> : ""}
                    </div>
                    <div className={numberval2 === 4? 'answer2 mt10px active' : 'answer2 mt10px'}>
                        {e.tabName === "Intra City" && numberval2 === 1 ? <IntraCityForm /> : ""}
                        {e.tabName === "Domestic" && numberval2 === 2 ? <DomesticForm /> : ""}
                        {e.tabName === "Part Load" && numberval2 === 3 ? <PartloadForm /> : ""}
                        {e.tabName === "Full Load" && numberval2 === 4 ? <FullloadForm /> : ""}
                        {e.tabName === "Packers & Movers" && numberval2 === 5 ? <PackersAndMoversForm /> : ""}
                        {e.tabName === "International" && numberval2 === 6  ? <InterNationalForm /> : ""}
                    </div>
                    <div className={numberval2 === 5? 'answer2 mt10px active' : 'answer2 mt10px'}>
                        {e.tabName === "Intra City" && numberval2 === 1 ? <IntraCityForm /> : ""}
                        {e.tabName === "Domestic" && numberval2 === 2 ? <DomesticForm /> : ""}
                        {e.tabName === "Part Load" && numberval2 === 3 ? <PartloadForm /> : ""}
                        {e.tabName === "Full Load" && numberval2 === 4 ? <FullloadForm /> : ""}
                        {e.tabName === "Packers & Movers" && numberval2 === 5 ? <PackersAndMoversForm /> : ""}
                        {e.tabName === "International" && numberval2 === 6  ? <InterNationalForm /> : ""}
                    </div>
                    <div className={numberval2 === 6? 'answer2 mt10px active' : 'answer2 mt10px'}>
                        {e.tabName === "Intra City" && numberval2 === 1 ? <IntraCityForm /> : ""}
                        {e.tabName === "Domestic" && numberval2 === 2 ? <DomesticForm /> : ""}
                        {e.tabName === "Part Load" && numberval2 === 3 ? <PartloadForm /> : ""}
                        {e.tabName === "Full Load" && numberval2 === 4 ? <FullloadForm /> : ""}
                        {e.tabName === "Packers & Movers" && numberval2 === 5 ? <PackersAndMoversForm /> : ""}
                        {e.tabName === "International" && numberval2 === 6  ? <InterNationalForm /> : ""}
                    </div>
                  </div>
                  )
            })}
          </div> */}
          </>
          <div className='homePageMobileVersionImagecontainer'>
            <img src='https://i.ibb.co/YhKbbL3/download-00.jpg' alt='TapTap.in'/>
          </div>
          <div className='homePageMobileContainer'>
            <div className='tabsList'>
              <div onClick={()=>handleTabsClick("intra-city")} className="servicesTabs"> <RiTruckLine className='intraCityIconHomePage'/> Intra City</div>
              <div onClick={()=>handleTabsClick("domestic")} className="servicesTabs"> <RiTruckLine className='intraCityIconHomePage'/> Domestic</div>
              <div onClick={()=>handleTabsClick("part-load")} className="servicesTabs"> <RiTruckLine className='intraCityIconHomePage'/> Part Load</div>
              <div onClick={()=>handleTabsClick("full-load")} className="servicesTabs"> <RiTruckLine className='intraCityIconHomePage'/> Full Load</div>
              <div onClick={()=>handleTabsClick("packers-and-movers")} className="servicesTabs"> <RiTruckLine className='intraCityIconHomePage'/> Packers & Movers</div>
              <div onClick={()=>handleTabsClick("international")} className="servicesTabs"> <RiTruckLine className='intraCityIconHomePage'/> International</div>
            </div>
          </div>
          <div className='homePageMobileVersionImagecontainerBottom mt-15Mobile'>
            <img src='https://i.ibb.co/YhKbbL3/download-00.jpg' alt='TapTap.in'/>
          </div>
          <div className='footerHomePageDiv'>
            <div style={{border:"0.2px solid tranparent"}}>
                <ul className="company-social" style={{textAlign:"center"}}>
                    <li className="social-facebook">
                        <a href="https://www.facebook.com/KabraExpressLogistics">
                            <i className="fa fa-facebook"></i>
                        </a>
                    </li>
                    <li className="social-twitter">
                        <a href="https://www.linkedin.com/company/kabra-express-logistics-private-limited/">
                            <i className="fa fa-linkedin"></i>
                        </a>
                    </li>
                    <li className="social-youtube">
                        <a href="https://www.instagram.com/kabra.express/">
                            <i className="fa fa-instagram"></i>
                        </a>
                    </li>
                    <li className="social-youtube">
                        <a href="https://www.youtube.com/channel/UCt4wx_zJAyQ-el--Jy3iurQ">
                            <i className="fab fa-youtube"></i>
                        </a>
                    </li>

                    <li className="social-twitter">
                        <a href="#">
                            <i className="fa fa-twitter"></i>
                        </a>
                    </li>
                </ul>
            </div>
            
            <div className="col-sm-6 col-md-6 text-center poweredByText">
              <strong>
                  Powered by{" "}
                  <img src="https://img.icons8.com/bubbles/40/000000/light-on.png" />{" "}
                  Kabra Express Logistics Pvt. Ltd.
              </strong>
            </div>
            {/* <a href="#" className="scrollup">
                <i className="fa fa-angle-up active"></i>
            </a> */}
          </div>
        </>
      ) : (
          <>
          <div className='homePageDiv'>
              <div className='headingNavbar'>
              <div className='homePageHeadingTabs'>
                <div className={tabValue === 0 ? "sixTabs active" : "sixTabs"}  onClick={() => handleChange(0)}>INTRA CITY</div>
                <div className={tabValue === 1 ? "sixTabs active" : "sixTabs"} onClick={() => handleChange(1)}>DOMESTIC</div>
                <div className={tabValue === 2 ? "sixTabs active" : "sixTabs"} onClick={() => handleChange(2)}>PART LOAD</div>
                <div className={tabValue === 3 ? "sixTabs active" : "sixTabs"} onClick={() => handleChange(3)}>FULL LOAD</div>
                <div className={tabValue === 4 ? "sixTabs active" : "sixTabs"} onClick={() => handleChange(4)}>PACKERS & MOVERS</div>
                <div className={tabValue === 5 ? "sixTabs active" : "sixTabs"} onClick={() => handleChange(5)}>INTERNATIONAL</div>
              </div>
              </div>
              <div className="contentOfheadingNavbar">
                <TabPanel value={tabValue} index={0}> <IntraCityForm /> </TabPanel>
                <TabPanel value={tabValue} index={1}> <DomesticForm /> </TabPanel>
                <TabPanel value={tabValue} index={2}> <PartloadForm /> </TabPanel>
                <TabPanel value={tabValue} index={3}> <FullloadForm /> </TabPanel>
                <TabPanel value={tabValue} index={4}> <PackersAndMoversForm /> </TabPanel>
                <TabPanel value={tabValue} index={5}> <InterNationalForm /> </TabPanel>
              </div>
          </div> 
          </>
      )}
    </Fragment>
  );
};

export default Home;
